import { postData } from '../plugins/ApiCalls'

export function fetchDashboardWidget(data) {
  return postData('dashboards/' + data.widget.type, data, { emulateJSON: true })
}

const DASHBOARD_PATHS = Object.freeze({
  CARDS: 'dashboard/cards',
  GRAPHS: 'dashboard/graphs'
})

function postDashboard(path, payload = {}) {
  return postData(path, payload)
}

export function fetchDashboardCards(payload) {
  return postDashboard(DASHBOARD_PATHS.CARDS, payload)
}

export function fetchDashboardGraphs(payload) {
  return postDashboard(DASHBOARD_PATHS.GRAPHS, payload)
}
